// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialInputs_container__3ZRd8","field":"SocialInputs_field__m2zIM"};